export const webhooksTranslations = {
  ar: {
    title: 'Webhooks',
    addNew: 'إضافة Webhook جديد',
    search: 'بحث...',
    name: 'الاسم',
    description: 'الوصف',
    url: 'رابط Webhook',
    eventType: 'نوع الحدث',
    status: 'الحالة',
    lastTriggered: 'آخر تشغيل',
    actions: 'الإجراءات',
    view: 'عرض',
    edit: 'تعديل',
    delete: 'حذف',
    test: 'اختبار',
    logs: 'السجلات',
    noWebhooks: 'لا توجد Webhooks',
    loading: 'جاري تحميل Webhooks...',
    error: 'فشل تحميل Webhooks',
    active: 'نشط',
    inactive: 'غير نشط',
    deleteSuccess: 'تم حذف Webhook بنجاح',
    deleteError: 'فشل حذف Webhook',
    testSuccess: 'تم اختبار Webhook بنجاح',
    testError: 'فشل اختبار Webhook',
    deletedWebhook: 'تم حذف Webhook:',
    viewedWebhook: 'عرض Webhook:',
    confirmDeleteMessage: 'هل أنت متأكد من حذف هذا Webhook؟',
    confirmDeleteTitle: 'تأكيد الحذف',
    confirmTestMessage: 'هل تريد اختبار هذا Webhook؟',
    confirmTestTitle: 'اختبار Webhook',
    failures: 'فشل:',
    viewWebhook: 'عرض Webhook',
    editWebhook: 'تعديل Webhook',
    newWebhook: 'Webhook جديد',
    basicInformation: 'المعلومات الأساسية',
    nameRequired: 'الاسم مطلوب',
    namePlaceholder: 'مثال: إشعار الفواتير المستحقة',
    urlRequired: 'رابط Webhook مطلوب',
    urlInvalid: 'يجب أن يبدأ الرابط بـ http:// أو https://',
    httpMethod: 'طريقة HTTP',
    retryCount: 'عدد المحاولات',
    timeoutSeconds: 'مهلة الانتظار (ثانية)',
    secretKey: 'مفتاح السري (للتوقيع HMAC)',
    secretKeyPlaceholder: 'مفتاح سري للتوقيع',
    secretKeyHint: 'سيتم إضافة توقيع HMAC في header X-Webhook-Signature',
    customHeaders: 'Headers مخصصة (JSON)',
    customHeadersHint: 'أدخل Headers كـ JSON object',
    saveFirst: 'يجب حفظ Webhook أولاً',
    supportedEventTypes: 'أنواع الأحداث المدعومة:',
    invoiceCreatedDesc: 'عند إنشاء فاتورة جديدة',
    invoiceDueDesc: 'عند استحقاق فاتورة',
    journalEntryPostedDesc: 'عند ترحيل قيد',
    recurringEntryGeneratedDesc: 'عند توليد قيد دوري',
    customEventsDesc: 'أحداث مخصصة',
    updatedWebhookLog: 'تم تحديث Webhook:',
    createdWebhookLog: 'تم إنشاء Webhook جديد:',
    saveWebhookError: 'فشل حفظ Webhook',
  },
  en: {
    title: 'Webhooks',
    addNew: 'Add New Webhook',
    search: 'Search...',
    name: 'Name',
    description: 'Description',
    url: 'Webhook URL',
    eventType: 'Event Type',
    status: 'Status',
    lastTriggered: 'Last Triggered',
    actions: 'Actions',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    test: 'Test',
    logs: 'Logs',
    noWebhooks: 'No webhooks',
    loading: 'Loading webhooks...',
    error: 'Failed to load webhooks',
    active: 'Active',
    inactive: 'Inactive',
    deleteSuccess: 'Webhook deleted successfully',
    deleteError: 'Failed to delete webhook',
    testSuccess: 'Webhook tested successfully',
    testError: 'Failed to test webhook',
    deletedWebhook: 'Deleted webhook:',
    viewedWebhook: 'Viewed webhook:',
    confirmDeleteMessage: 'Are you sure you want to delete this webhook?',
    confirmDeleteTitle: 'Confirm Delete',
    confirmTestMessage: 'Do you want to test this webhook?',
    confirmTestTitle: 'Test Webhook',
    failures: 'Failures:',
    viewWebhook: 'View Webhook',
    editWebhook: 'Edit Webhook',
    newWebhook: 'New Webhook',
    basicInformation: 'Basic Information',
    nameRequired: 'Name is required',
    namePlaceholder: 'Example: Invoice Due Notifications',
    urlRequired: 'Webhook URL is required',
    urlInvalid: 'URL must start with http:// or https://',
    httpMethod: 'HTTP Method',
    retryCount: 'Retry Count',
    timeoutSeconds: 'Timeout (seconds)',
    secretKey: 'Secret Key (for HMAC signature)',
    secretKeyPlaceholder: 'Secret key for signing',
    secretKeyHint: 'HMAC signature will be added in X-Webhook-Signature header',
    customHeaders: 'Custom Headers (JSON)',
    customHeadersHint: 'Enter headers as JSON object',
    saveFirst: 'Please save webhook first',
    supportedEventTypes: 'Supported Event Types:',
    invoiceCreatedDesc: 'When a new invoice is created',
    invoiceDueDesc: 'When an invoice becomes due',
    journalEntryPostedDesc: 'When a journal entry is posted',
    recurringEntryGeneratedDesc: 'When a recurring entry is generated',
    customEventsDesc: 'Custom events',
    updatedWebhookLog: 'Updated webhook:',
    createdWebhookLog: 'Created new webhook:',
    saveWebhookError: 'Failed to save webhook',
  },
  fr: {
    title: 'Webhooks',
    addNew: 'Ajouter un nouveau Webhook',
    search: 'Rechercher...',
    name: 'Nom',
    description: 'Description',
    url: 'URL du Webhook',
    eventType: 'Type d\'événement',
    status: 'Statut',
    lastTriggered: 'Dernier déclenchement',
    actions: 'Actions',
    view: 'Voir',
    edit: 'Modifier',
    delete: 'Supprimer',
    test: 'Tester',
    logs: 'Journaux',
    noWebhooks: 'Aucun webhook',
    loading: 'Chargement des webhooks...',
    error: 'Échec du chargement des webhooks',
    active: 'Actif',
    inactive: 'Inactif',
    deleteSuccess: 'Webhook supprimé avec succès',
    deleteError: 'Échec de la suppression du webhook',
    testSuccess: 'Webhook testé avec succès',
    testError: 'Échec du test du webhook',
  },
}

